jQuery(function () {
	// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	const button = jQuery('.navbar-toggler');
	// Return early if the button don't exist.
	if ('undefined' === typeof button) {
		return;
	}
	button.on('click', function () {
		if (jQuery('body').hasClass('bm-Menu--Expanded')) {
			jQuery('body').addClass('bm-Menu--Collapsing');
			setTimeout(function () {
				jQuery('body').removeClass('bm-Menu--Collapsing');
			}, 700);
			jQuery('body').removeClass('bm-Menu--Expanded');
		} else {
			jQuery('body').addClass('bm-Menu--Expanded');
		}
	});
});

// On document ready:
jQuery(document).ready(function () {
	// Get all the dropdown menu items
	const dropdowns = document.querySelectorAll('ul .menu-item-has-children');

	// Check if the viewport is under 1200px
	if (window.innerWidth < 998) {
		// Loop through each dropdown menu item
		jQuery(document).ready(function ($) {
			//$('.dropdown-menu').hide();
			$('.menu-item-has-children > a').click(function (e) {
				e.preventDefault();
				if ($(this).parent().hasClass('focus')) {
					window.location.href = $(this).attr('href');
				} else {
					$(this).parent().addClass('focus');
				}
			});
		});
	}
});
